/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/
import type { Ref, RefCallback, RefObject } from "react";

export function setRefValue<T>(value: T | null, ref: Ref<T> | undefined): void {
	if (!ref) return;
	switch (typeof ref) {
		case "function":
			ref(value);
			return;
		case "object":
			ref.current = value;
			return;
	}
}

export function mergeRefs<T = any>(refs: Array<RefObject<T> | Ref<T>>): RefCallback<T> {
	return (value) => {
		refs.forEach((ref) => {
			setRefValue(value, ref);
		});
	};
}

export function useMergedRefs<T>(...refs: (Ref<T> | undefined)[]): RefCallback<T> {
	return (value) => {
		for (const ref of refs) {
			setRefValue(value, ref);
		}
	};
}
